//IMPORTING COLORS
import { WHITE, PRIMARY_BTN_GK } from "./utils/colors";

//IMPORT NUMBERS
import {
  WHATS_APP_LINK,
  WHATS_APP_TEXT,
  WHATS_APP_COMERCIAL_LINK,
  WHATS_APP_COMERCIAL_TEXT,
} from "./utils/phoneNumbers";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import PagesRoutes from "./Routes/routes";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";
import MainModal from "./components/MainModal";

export default function App() {
  useEffect(() => {
    const loader = document.getElementById("loading-page");
    loader.style.display = "none";
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <MainModal />
        <Header
          white={WHITE}
          btnColor={PRIMARY_BTN_GK}
          whatsAppNumber={WHATS_APP_LINK}
          whatsAppText={WHATS_APP_TEXT}
          whatsAppComercialLink={WHATS_APP_COMERCIAL_LINK}
          whatsAppComercialText={WHATS_APP_COMERCIAL_TEXT}
        />
        <PagesRoutes />
        <Footer
          white={WHITE}
          whatsAppNumber={WHATS_APP_LINK}
          whatsAppText={WHATS_APP_TEXT}
          whatsAppComercialLink={WHATS_APP_COMERCIAL_LINK}
          whatsAppComercialText={WHATS_APP_COMERCIAL_TEXT}
        />
      </BrowserRouter>
    </HelmetProvider>
  );
}
